import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import TeamPage from "@/pages/TeamPage";
import ServicesPage from "@/pages/ServicesPage";
import PricingPage from "@/pages/PricingPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import AppointmentPage from "@/pages/AppointmentPage";

function App() {
  return (
    <div className="App" data-testid="app">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/za-nas" element={<AboutPage />} />
          <Route path="/ekip" element={<TeamPage />} />
          <Route path="/uslugi" element={<ServicesPage />} />
          <Route path="/ceni" element={<PricingPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/kontakti" element={<ContactPage />} />
          <Route path="/zapazi-chas" element={<AppointmentPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
